// Display helper for per-option follow-ups: which option of a multiselect
// parent does this question belong to? Used to render a "For: <option>" chip
// next to the label in the company questionnaire and the admin review list.
// Applies to authored rows and mirrors alike (both carry a string condition).

import type { Question } from './types.ts';

export function instanceOptionLabel(
  question: Question,
  byId: Map<string, Question>,
): string | null {
  if (!question.parent_id || !question.condition) return null;
  const parent = byId.get(question.parent_id);
  if (!parent) return null;
  if (parent.type !== 'multiselect' && parent.type !== 'multiselect_uploads') return null;
  return typeof question.condition.value === 'string' ? question.condition.value : null;
}
